import React from "react";
import NewCars from "../components/new-cars/index.jsx";
import SeoMeta from "../components/meta";

export default function NewCarPage() {
  return (
    <>
      <SeoMeta
        title="New car Prices | Famewheels"
        desc="Discover the latest new car prices in Pakistan with Famewheels. Stay updated and make informed decisions about new cars. Explore now for accurate and reliable pricing information."
        url="new-cars"
      />

      <NewCars />
    </>
  );
}
